import { RootState } from '../../stores/store.ts';

export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;
export const selectCurrentUser = (state: RootState) => state.auth.user;
export const selectIsAuth = (state: RootState) => state.auth.user !== null;